import React from 'react'
import './footer.css'
import LottieAnimation from '../../Lottie'
import Heart from '../../Animations/Heart.json'

function footer() {
    return (
        <div className="bg-gray-900 mt-1">
            <p class="rounded-md text-sm font-medium text-center text-gray-500 mt-10 pt-2">
                {/* Portfolio Inspired From: https://www.theelipan.com/ */}
            </p>
            <p class="rounded-md text-sm font-medium text-center text-gray-300 mt-1 py-3">
                <div className="bg-gray-900 flex items-center justify-center -mt-14 -mb-14">
                <div className="-mr-12">Made with</div> <div><LottieAnimation lotti={Heart} width={150} height={150}/></div> <div className="-ml-12">by</div> <span className="antialiased font-extrabold text-base px-1">Sid</span>
                </div>
            </p>
            {/* <div className="flex items-center justify-center py-3 text-sm">
                    <span className="footer-text text-gray-300 rounded-md text-sm font-base">Made with <span>‏‏‎ ‎❤️ ‏‏‎ ‎</span> by <span className="antialiased font-extrabold">Sid</span>.</span>
                </div> */}
        </div>
    )
}

export default footer

// ‎❤️ ‏‏‎ ‎